import { render, staticRenderFns } from "./PageBack.vue?vue&type=template&id=6605b63a"
import script from "./PageBack.vue?vue&type=script&lang=js"
export * from "./PageBack.vue?vue&type=script&lang=js"
import style0 from "./PageBack.vue?vue&type=style&index=0&id=6605b63a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports